import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { actions, selectors } from 'builder/modules/resumeEditor'
import { useTailoredDesignation } from 'builder/hooks/useTailoredDesignation'
import { DeleteJobPosting } from 'builder/components/ResumeScore'
import { JobPostingDetails } from '../../components/JobPostingDetails/JobPostingDetails'
import { JobPostingContainer } from '../../styles'
import { JobPostingProps } from '../../types'

export const JobPostingAttachedStep = (props: JobPostingProps) => {
  const { children } = props
  const {
    jobPostingAPIData: { jobPostingId, recommendedJobTitle, employerName, averageScore },
  } = useTypedSelector(selectors.optimizerSection)
  const resume = useTypedSelector(selectors.resume)
  const tailoredDesignation = useTailoredDesignation(recommendedJobTitle, employerName)
  const dispatch = useDispatch()
  const isClickedOnDeleteJobPosting = useTypedSelector(
    state => state.resumeEditor.isClickedOnDeleteJobPosting,
  )

  const handleDeleteJobPosting = () => {
    if (resume?.id && jobPostingId) {
      dispatch(
        actions.deleteJobPosting({ jobPostingId, resumeId: resume?.id, shouldRefreshPage: false }),
      )
      dispatch(actions.setIsClickedOnDeleteJobPosting(false))
      trackInternalEvent('click_confirm_delete_job_title_resume_optimizer')
    }
  }

  const handleCancelDeleteJobPosting = () => {
    dispatch(actions.setIsClickedOnDeleteJobPosting(false))
  }

  const handleClickDeleteJobPosting = () => {
    dispatch(actions.setIsClickedOnDeleteJobPosting(true))
    trackInternalEvent('click_clear_job_title_resume_optimizer')
  }

  return (
    <>
      <JobPostingContainer>
        <JobPostingDetails
          title={tailoredDesignation}
          score={averageScore}
          onChangeLink={handleClickDeleteJobPosting}
        />
        {isClickedOnDeleteJobPosting && (
          <DeleteJobPosting
            handleDeleteJobPosting={handleDeleteJobPosting}
            handleCancelDeleteJobPosting={handleCancelDeleteJobPosting}
          />
        )}
      </JobPostingContainer>
      {children}
    </>
  )
}
